// extracted by css-extract-rspack-plugin
export default {"issueDependenciesList":"DependencyEvent-module__issueDependenciesList__N9YcV","issueDependencyItem":"DependencyEvent-module__issueDependencyItem__jvNBO"};